const locale = {
    placeholder: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
};
export default locale;
